import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import useGetRowData from '../hooks/useGetRowData';
import CreateEditAgeHoursForm from './CreateEditAgeHoursForm';
import { EditAgeHoursSkeleton } from './EditAgeHoursSkeleton';

type Props = {
  isCopied: boolean;
};

export default function CreateEditAgeHours({
  handleClose,
  rowId,
  isCopied
}: FormComponentProps & Props) {
  const { isFetching, data } = useGetRowData(convertToNumber(rowId));

  return isFetching ? (
    <EditAgeHoursSkeleton />
  ) : (
    <CreateEditAgeHoursForm
      handleClose={handleClose}
      isCopied={isCopied}
      rowData={data}
    />
  );
}
